var path = 'common/components/toggle-switch/toggle-switch.html';
var html = "<div class=\"toggle-switch\">\n\t<label class=\"side-label\" ng-class=\"{'side-on': !$toggleSwitchCtrl.rightChoiceOn}\">{{$toggleSwitchCtrl.leftChoiceText}}</label>\n\t<label class=\"switch\">\n\t\t<input type=\"checkbox\" ng-click=\"$toggleSwitchCtrl.rightChoiceOn = !$toggleSwitchCtrl.rightChoiceOn\">\n\t\t<div class=\"slider round\"></div>\n\t</label>\n\t<label class=\"side-label\" ng-class=\"{'side-on': $toggleSwitchCtrl.rightChoiceOn}\">{{$toggleSwitchCtrl.rightChoiceText}}</label>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./common/components/toggle-switch/toggle-switch.html
// module id = ./common/components/toggle-switch/toggle-switch.html
// module chunks = 0